import { forwardRef, type ElementType, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type BoxProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
};

export const Box = forwardRef<HTMLElement, BoxProps>(({ as: Component = "div", className, ...props }, ref) => (
  <Component ref={ref} className={cn(className)} {...props} />
));

Box.displayName = "Box";
